<mat-card appearance="outlined" class="col-12">
  @if (message) {
    <mat-card-header>
      {{ message.title }}
    </mat-card-header>
  }
  <mat-card-content [innerHtml]="message?.message" />
</mat-card>
